var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { ReportingFilterOption } from "@irati/types";
import { FormattedMessage } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
import Expander from "@irati/ui/src/Expander";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { Hr } from "@irati/ui/src/Layout";
import { MockPerkFilter, MockPerkCategoryFilter, TeamFilter } from "./";
import { FilterSectionDiv, MarginPara } from "./styled";
var FilterExpander = /** @class */ (function (_super) {
    __extends(FilterExpander, _super);
    function FilterExpander() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expander = React.createRef();
        _this.allowFilter = function (filter) { var _a; return (_a = _this.props.filters) === null || _a === void 0 ? void 0 : _a.includes(filter); };
        _this.handleApply = function () {
            if (_this.expander.current) {
                _this.expander.current.close();
            }
            _this.props.handleApply();
        };
        return _this;
    }
    FilterExpander.prototype.render = function () {
        var _a = this.props, filterValues = _a.filterValues, filterChangeHandler = _a.filterChangeHandler;
        return (React.createElement(FilterSectionDiv, null,
            React.createElement(Expander, { ref: this.expander, fullWidth: true, Header: function () { return (React.createElement(Flex, { alignItems: "center" },
                    React.createElement(Icon, { icon: IconTypes.filter }),
                    React.createElement(MarginPara, { flush: true },
                        React.createElement(FormattedMessage, { id: "admin.reportingV3.segmentAndFilter.filterTitle" })))); } },
                React.createElement(Hr, null),
                React.createElement(Flex, { margin: "5px", width: "100%", justifyContent: "space-between" },
                    this.allowFilter(ReportingFilterOption.PerkUuid) &&
                        React.createElement(MockPerkFilter, { value: filterValues[ReportingFilterOption.PerkUuid] || "", onChange: function (values) { return filterChangeHandler(ReportingFilterOption.PerkUuid, values); } }),
                    this.allowFilter(ReportingFilterOption.PerkCategory) &&
                        React.createElement(MockPerkCategoryFilter, { value: filterValues[ReportingFilterOption.PerkCategory] || "", onChange: function (values) { return filterChangeHandler(ReportingFilterOption.PerkCategory, values); } }),
                    this.allowFilter(ReportingFilterOption.Team) &&
                        React.createElement(TeamFilter, { value: filterValues[ReportingFilterOption.Team] || "", onChange: function (values) { return filterChangeHandler(ReportingFilterOption.Team, values); } })),
                React.createElement(Flex, { width: "100%", direction: "row-reverse" },
                    React.createElement(Button, { primary: true, onClick: this.handleApply },
                        React.createElement(FormattedMessage, { id: "admin.reportingV3.segmentAndFilter.applyButton" }))))));
    };
    return FilterExpander;
}(PureComponent));
export default FilterExpander;
